<template>
    <div class="content">
        <div class="container">
            <!-- title -->
            <div class="row ki_block_title">
                <div class="col-12">
                    <h1 class="title mt_sm">Избранное</h1>
                </div>
            </div>
            <!-- // title -->

            <template v-for="(item, index) in items">
                <!-- cart_item -->
                <div class="row cart_item underlined_item">
                    <div class="col-12 col-lg-8 mt_xxs">
                        <div class="media ki_group">
                            <div class="ki_p">
                                <div
                                    v-if="item.is_new"
                                    class="cg_i item_icon item_icon_left"
                                >
                                    <img src="/i/new.svg" alt="Новинка" />
                                </div>
                                <div
                                    v-if="item.is_bestseller"
                                    class="cg_i item_icon item_icon_left"
                                >
                                    <img src="/i/hit.svg" alt="Хит" />
                                </div>
                                <div
                                    v-if="item.is_sale"
                                    class="cg_i item_icon item_icon_left"
                                >
                                    <img src="/i/sale.svg" alt="Распродажа" />
                                </div>

                                <a :href="'/catalog/item/' + item.slug">
                                    <div class="item_picture">
                                        <template v-if="item.images.length > 0">
                                            <div
                                                :style="
                                                    'background-image: url(/storage/' +
                                                    item.images[0].path
                                                "
                                            ></div>
                                        </template>
                                        <template v-else>
                                            <div style=""></div>
                                        </template>
                                    </div>
                                </a>
                            </div>

                            <div class="media-body">
                                <div class="ki_title subtitle">
                                    <a :href="'/catalog/item/' + item.slug">{{
                                        item.title
                                        }}</a>
                                </div>

                                <div class="ki_info item_info item_info_horizontal">
                                    <p v-if="item.attr_color"><span>Цвет</span> {{ item.attr_color }}</p>
                                    <p v-if="item.attr_size"><span>Размер</span> {{ item.attr_size }}</p>
                                    <p v-if="item.attr_material"><span>Материал</span> {{ item.attr_material }}</p>
                                    <p v-if="item.attr_type"><span>Тип</span> {{ item.attr_type }}</p>
                                    <p v-if="item.country"><span>Производитель</span> {{ item.country }}</p>
                                    <p v-if="item.attr_other"><span>Прочее</span> {{ item.attr_other }}</p>
                                    <p><span>Артикул</span> {{ item.sku }}</p>
                                </div>
                                <div class="ki_small small_info">
                                    <span class="stock_xs">В наличии.</span> В
                                    упаковке по
                                    <span class="accent">{{ item.qty_per_pack }} ед.</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-4 mt_xxs">
                        <div class="ki_price">

                            <span v-if="item.old_price && item.old_price !== item.price" class="other_lg">
                                <s>{{ item.old_price }} р.</s>
                            </span>

                            <span class="price_lg">
                                {{ item.price }} р.
                            </span>
                        </div>

                        <div class="ki_action">
                            <div class="ki_move small_list">
                                <a href="#" @click.prevent="deleteFromFavourites(item.id)">Удалить</a>
                                <a v-if="!inCart(item.id)" href="#"
                                    @click.prevent="addToCart(item.id, item.qty_per_pack)">В корзину</a>
                                <a v-else href="#" @click.prevent="deleteFromCart(item.id)">В корзине</a>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- //cart_item -->
            </template>

            <div v-if="!items.length" class="row">
                <div class="col-12 mt_md">

                    <div class="box">
                        <div class="title">В избранном пока пусто</div>
                        <div class="text mt_xs">
                            <p>Добавьте сюда товары, к которым хотите иметь быстрый доступ</p>
                        </div>
                    </div>

                </div>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    methods: {
        deleteFromFavourites(id) {
            this.$store.dispatch('favourites/deleteFromFavourites', id);
        },

        inCart(id) {
            return this.$store.state.cart.items.find(x => x.id == id);
        },

        addToCart(id, qty) {
            this.$store.dispatch('cart/addToCart', {
                id: id,
                qty: qty,
            })
        },

        deleteFromCart(id) {
            this.$store.dispatch('cart/deleteFromCart', id)
        }
    },

    computed: {
        items() {
            return this.$store.state.favourites.items;
        },
    },
};
</script>
